import { twMerge } from "tailwind-merge"

export const HeadingCustom = ({ children, type = "h2", size = "medium", className }) => {
    const mySize = {
        large: "lg:text-6xl text-4xl mb-8",
        medium: "text-4xl text-xl mb-4",
        small: "text-lg text-xs mb-2"
    }

    const myType = {
        h1: "h1",
        h2: "h2",
        h3: "h3"
    }

    const Tag = myType[type] || "h2"

    return (
        <Tag className={twMerge(`tracking-tighter font-bold ${mySize[size]}`, className)}>
            {children}
        </Tag>
    )
}